(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enamor-x-pdp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', initEFW);
document.addEventListener('DOMContentLoaded', initEFW);

function initEFW(){
  const roots = document.querySelectorAll('[id^="enamor-fweek-"]');
  if(!roots.length) return;

  roots.forEach(root=>{
    // Normalize iframe params for UI + autoplay
    root.querySelectorAll('[data-embed] iframe').forEach(f=>{
      try{
        const u = new URL(f.src, location.origin);
        if(u.hostname.includes('youtube.com')){
          u.searchParams.set('controls','1');
          u.searchParams.set('autoplay','1');
          u.searchParams.set('mute','1');
          u.searchParams.set('playsinline','1');
          u.searchParams.set('rel','0');
          u.searchParams.set('enablejsapi','1');
          f.src = u.toString();
        } else if(u.hostname.includes('player.vimeo.com')){
          u.searchParams.set('controls','1');
          u.searchParams.set('autoplay','1');
          u.searchParams.set('muted','1');
          f.src = u.toString();
        }
        f.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        f.setAttribute('allowfullscreen','');
        f.style.pointerEvents = 'auto';
      }catch(e){}
    });

    // Wire up per-card controls
    root.querySelectorAll('.enamor-fweek__video').forEach(card=>{
      const vid = card.querySelector('video');
      const iframe = card.querySelector('iframe');
      const btnUnmute = card.querySelector('[data-unmute]');
      const btnMute = card.querySelector('[data-mute]');
      const btnPlay = card.querySelector('[data-play]');
      const btnPause = card.querySelector('[data-pause]');

      function setButtons(state){
        if(state.muted){
          btnUnmute.hidden = false;
          btnMute.hidden = true;
        } else {
          btnUnmute.hidden = true;
          btnMute.hidden = false;
        }
        if(state.playing){
          btnPlay.hidden = true;
          btnPause.hidden = false;
        } else {
          btnPlay.hidden = false;
          btnPause.hidden = true;
        }
      }

      if(vid){
        vid.controls = true;
        vid.muted = true;
        vid.playsInline = true;
        vid.addEventListener('loadeddata', ()=> {
          try { vid.currentTime = 0; vid.play().then(()=>setButtons({playing:true, muted:vid.muted})).catch(()=>setButtons({playing:false, muted:vid.muted})); } catch(e){}
        }, { once:true });

        btnUnmute.addEventListener('click', ()=>{ vid.muted = false; setButtons({playing:!vid.paused, muted:false}); vid.play().catch(()=>{}); });
        btnMute.addEventListener('click', ()=>{ vid.muted = true; setButtons({playing:!vid.paused, muted:true}); });
        btnPlay.addEventListener('click', ()=>{ vid.play().then(()=>setButtons({playing:true, muted:vid.muted})).catch(()=>{}); });
        btnPause.addEventListener('click', ()=>{ vid.pause(); setButtons({playing:false, muted:vid.muted}); });

        vid.addEventListener('play', ()=>setButtons({playing:true, muted:vid.muted}));
        vid.addEventListener('pause', ()=>setButtons({playing:false, muted:vid.muted}));
        vid.addEventListener('volumechange', ()=>setButtons({playing:!vid.paused, muted:vid.muted}));
      }

      if(iframe){
        setButtons({playing:true, muted:true});
        const host = (()=>{ try{ return new URL(iframe.src); }catch(e){ return null; } })();

        function yt(cmd){
          iframe.contentWindow?.postMessage(JSON.stringify({ event:'command', func: cmd, args:[] }), '*');
        }
        function vm(message){
          if(!host) return;
          iframe.contentWindow?.postMessage(message, host.origin);
        }

        btnUnmute.addEventListener('click', ()=>{
          if(host && host.hostname.includes('youtube.com')) yt('unMute');
          else if(host && host.hostname.includes('player.vimeo.com')) vm({ method:'setVolume', value:1 });
          setButtons({playing:true, muted:false});
        });
        btnMute.addEventListener('click', ()=>{
          if(host && host.hostname.includes('youtube.com')) yt('mute');
          else if(host && host.hostname.includes('player.vimeo.com')) vm({ method:'setVolume', value:0 });
          setButtons({playing:true, muted:true});
        });
        btnPlay.addEventListener('click', ()=>{
          if(host && host.hostname.includes('youtube.com')) yt('playVideo');
          else if(host && host.hostname.includes('player.vimeo.com')) vm({ method:'play' });
          setButtons({playing:true, muted:btnMute.hidden === false});
        });
        btnPause.addEventListener('click', ()=>{
          if(host && host.hostname.includes('youtube.com')) yt('pauseVideo');
          else if(host && host.hostname.includes('player.vimeo.com')) vm({ method:'pause' });
          setButtons({playing:false, muted:btnMute.hidden === false});
        });
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
